import { Dispatch, GetBaseState } from '@lumapps/redux/types';
import { getAcceptedContributionLanguageHeader } from '@lumapps/translations/ducks/selectors';
import { actions as widgetActions } from '@lumapps/widget-base/ducks/slice';

import { Layout } from '../types';
import { formatFilterLayoutWidgets } from '../utils/formatFilterLayoutWidgets';

/**
 * Generic layout fetch & update widget store.
 * Used for content & space layouts.
 */
export const fetchLayout =
    <T>(options: {
        fetchParams: T;
        fetch: (fetchParams: T, languages: string) => Promise<Layout>;
        enabledWidgetTypes?: string[];
    }) =>
    async (dispatch: Dispatch, getState: GetBaseState): Promise<Layout> => {
        const { fetchParams, fetch, enabledWidgetTypes } = options;

        const state = getState();
        const acceptLanguageHeader = getAcceptedContributionLanguageHeader(state);

        const layout = await fetch(fetchParams, acceptLanguageHeader);

        // Format/Filter layout widgets.
        const formatted = formatFilterLayoutWidgets(layout, enabledWidgetTypes);

        // Set widget states in store.
        if (formatted.preloadedWidgets.length || formatted.widgetRefs.length) {
            dispatch(
                widgetActions.setWidgets({
                    preloadedWidgets: formatted.preloadedWidgets,
                    widgetRefs: formatted.widgetRefs,
                }),
            );
        }

        return formatted.layout;
    };
